import { useReveal, useWindowEvent } from '@ccg/core';
import React$1, { useState, useCallback, useEffect } from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import SpecialHeadline$1 from '../SpecialHeadline/SpecialHeadline.js';
import Tags$1 from '../Tags/Tags.js';
import Form$1 from '../Form/Form.js';
import StyledJobTeaser from './JobTeaser.style.js';

const JobTeaser = ({
  title,
  locations,
  link,
  companies,
  isFormTeaser,
  form,
  subline
}) => {
  const [ref, isVisible] = useReveal();
  const [formToggle, setFormToggle] = useState(false);
  const handleResize = useCallback(() => {
    if (!isFormTeaser) return;
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    setFormToggle(isMobile);
  }, []);
  useEffect(() => handleResize(), []);
  useWindowEvent('resize', () => handleResize());
  return /*#__PURE__*/React$1.createElement(StyledJobTeaser, {
    isVisible: isVisible,
    isExternal: companies && companies.length > 0 && !companies[0].title.toLowerCase().includes('fischerappelt'),
    isFormTeaser: isFormTeaser
  }, isFormTeaser ? /*#__PURE__*/React$1.createElement("div", {
    className: "jobTeaser__formTeaser",
    ref: ref
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "jobTeaser__wrapper"
  }, companies && companies.length > 0 && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "jobTeaser__companies",
    variant: "small"
  }, companies.map(company => company.title).join(' | ')), /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    as: "h2",
    variant: "intro",
    text: title
  }), /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "jobTeaser__subline"
  }, subline)), /*#__PURE__*/React$1.createElement("div", {
    className: "jobTeaser__form"
  }, /*#__PURE__*/React$1.createElement(Form$1, _extends({}, form, {
    formToggle: formToggle ? form.formToggle : null,
    hasGrid: false,
    linkTo: null
  })))) : /*#__PURE__*/React$1.createElement(Link$1, _extends({}, link, {
    noHover: true,
    className: "jobTeaser__link"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "jobTeaser__wrapper",
    ref: ref
  }, companies && companies.length > 0 && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "jobTeaser__companies",
    variant: "small"
  }, companies.map(company => company.title).join(' | ')), /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    as: "h2",
    variant: "intro",
    text: title
  }), locations && /*#__PURE__*/React$1.createElement("div", {
    className: "jobTeaser__locations"
  }, locations.length > 0 && /*#__PURE__*/React$1.createElement(Tags$1, {
    className: "jobTeaser__tags",
    horizontal: true,
    tags: locations,
    variant: "small"
  })), /*#__PURE__*/React$1.createElement("span", {
    className: "jobTeaser__link-text"
  }, "Details"))));
};

JobTeaser.propTypes = {
  title: PropTypes$1.string.isRequired,
  subline: PropTypes$1.string,
  link: PropTypes$1.shape().isRequired,
  locations: PropTypes$1.arrayOf(PropTypes$1.shape()),
  companies: PropTypes$1.arrayOf(PropTypes$1.shape()),
  form: PropTypes$1.shape(),
  isFormTeaser: PropTypes$1.bool
};
JobTeaser.defaultProps = {
  locations: null,
  companies: null,
  subline: null,
  form: null,
  isFormTeaser: null
};

export default JobTeaser;
